/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { Icon } from '../../utils/Icon'

type CategoryHelpDialog = {
  isOpen?: boolean
  onClose: () => void
}

export const CategoryHelpDialog = ({ isOpen, onClose }: CategoryHelpDialog) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      css={css`
        position: fixed;
        z-index: 10;
        inset: 0;
        overflow-y: auto;
        padding: 0px 20px;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
        `}
      >
        <DialogBackdrop
          css={css`
            position: fixed;
            inset: 0;
            background-color: black;
            opacity: 0.3;
          `}
        />

        <Card>
          <CloseButton onClose={onClose} />
          <Heading>病児とは</Heading>
          <Paragraph>
            風邪などの「入院するほど重篤ではないものの、保育園・学校などを休まなければならない」子どものことをいいます。
          </Paragraph>
          <Heading
            css={css`
              margin-top: 25px;
            `}
          >
            病後児とは
          </Heading>
          <Paragraph>「病気が回復期にある」子どものことをいいます。</Paragraph>
        </Card>
      </div>
    </Dialog>
  )
}

const Card = styled(DialogPanel)(css`
  position: relative;
  background-color: white;
  border-radius: 20px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  padding: 30px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
`)

const Heading = styled.div(css`
  font-weight: bold;
  font-size: 14px;
  line-height: 160%;
  color: #000000;
  margin-bottom: 10px;
`)

const Paragraph = styled.p(css`
  font-size: 12px;
  line-height: 160%;
  color: #000000;
`)

const CloseButton = (props: { onClose: VoidFunction }) => {
  return (
    <span
      role="button"
      aria-label="閉じる"
      css={closeButtonStyle}
      onClick={props.onClose}
    >
      <Icon iconName="close-circle" />
    </span>
  )
}

const closeButtonStyle = css`
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  transform: translate(12px, -12px);
  & > svg {
    width: 24px;
    height: 24px;
    display: block;
  }
`
